import { Form, Input } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { SecondaryText, FormItemNoMargin, FullWidthButton } from './styles/ResetPasswordFormStyles'

interface ResetPasswordFormProps {
  onFinish: (values: { password: string; confirmPassword: string }) => void
  loading: boolean
}

export function ResetPasswordForm({ onFinish, loading }: ResetPasswordFormProps) {
  const [form] = Form.useForm()

  return (
    <Form
      form={form}
      name="reset-password"
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      size="large"
    >
      <SecondaryText type="secondary">Enter your new password below.</SecondaryText>

      <Form.Item
        name="password"
        rules={[
          { required: true, message: 'Please input your new password!' },
          { min: 6, message: 'Password must be at least 6 characters!' },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="New password"
          autoComplete="new-password"
        />
      </Form.Item>

      <Form.Item
        name="confirmPassword"
        dependencies={['password']}
        rules={[
          { required: true, message: 'Please confirm your password!' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve()
              }
              return Promise.reject(new Error('Passwords do not match!'))
            },
          }),
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="Confirm new password"
          autoComplete="new-password"
        />
      </Form.Item>

      <FormItemNoMargin>
        <FullWidthButton type="primary" htmlType="submit" loading={loading}>
          Reset password
        </FullWidthButton>
      </FormItemNoMargin>
    </Form>
  )
}
